var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"prescriber"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('pages.manager.edit')))]),_vm._v(" "),_c('p',{staticClass:"address-for-qr"},[_vm._v(_vm._s(_vm.$t('pages.manager.address_for_qr')))]),_vm._v(" "),_c('b-container',[_c('ajax-edit',{attrs:{"name":_vm.name,"uri":_vm.uri,"id":_vm.id,"additionnal-route":_vm.additionnalRoute,"config":{ headers: { 'Content-Language': _vm.$translation.getLocale() } },"default-model-values":{
        'address': {
          'country': null,
          'street': null,
          'street_comp': null,
          'zip_code': null,
          'city': null
        }
      },"fields-filter-list":_vm.parametersNotCompleted ? ['email'] : []}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4665b626","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Manager/edit.vue
// module id = 891
// module chunks = 1